import React, { useEffect, useState } from 'react';
import styles from './Navbar.module.css';

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Education', href: '#education' },
  { label: 'Skills', href: '#skills' },
  { label: 'Certifications', href: '#certifications' },
  { label: 'Projects', href: '#projects' },
];

interface NavbarProps {
  alwaysScrolled?: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ alwaysScrolled = false }) => {
  const [scrolled, setScrolled] = useState(alwaysScrolled);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (alwaysScrolled) return;
    setScrolled(window.scrollY > 20);
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [alwaysScrolled]);

  const handleNavClick = () => setMenuOpen(false);

  return (
    <nav className={`${styles.navbar} ${scrolled ? styles.scrolled : ''}`}>
      <div className={styles.inner}>
        <a href="#about" className={styles.logo} aria-label="Home">
          <svg width="36" height="38" viewBox="0 0 36 38" fill="none" aria-hidden="true">
            {/* Trunk */}
            <rect x="8" y="21" width="5" height="14" rx="1.5" fill="#7D5A3C" />
            {/* Canopy - back layer */}
            <circle cx="10" cy="14" r="12" fill="#2A6B22" />
            {/* Canopy - front highlight */}
            <circle cx="10" cy="11" r="9" fill="#3D8B30" />
            {/* Apple - bilobed path so it reads as apple not tomato */}
            <path
              d="M23 28 C21.5 26 19 27 19 29.5 C19 33 21 35.5 23 35.5 C25 35.5 27 33 27 29.5 C27 27 24.5 26 23 28 Z"
              fill="#C8281E"
            />
            {/* Top indent to complete the bilobed silhouette */}
            <path
              d="M23 28 C23 26.5 23 25.5 23 25.5"
              stroke="#A01E15"
              strokeWidth="1.2"
              strokeLinecap="round"
            />
            {/* Stem */}
            <path d="M23 25.5 C23 24 24.5 23 26 22.5" stroke="#5C3D1E" strokeWidth="1" strokeLinecap="round" />
            {/* Leaf */}
            <path d="M23 25 C24 23 27 23 27 25 C27 25 25.5 26 23 25 Z" fill="#3D8B30" />
            {/* Shine */}
            <ellipse cx="21.5" cy="30" rx="0.8" ry="1.2" fill="rgba(255,255,255,0.22)" />
          </svg>
        </a>

        <button
          className={styles.hamburger}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          <span className={`${styles.bar} ${menuOpen ? styles.barTop : ''}`} />
          <span className={`${styles.bar} ${menuOpen ? styles.barMid : ''}`} />
          <span className={`${styles.bar} ${menuOpen ? styles.barBot : ''}`} />
        </button>

        <ul className={`${styles.links} ${menuOpen ? styles.open : ''}`}>
          {NAV_LINKS.map(({ label, href }) => (
            <li key={href}>
              <a href={href} className={styles.link} onClick={handleNavClick}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
